exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card{color:red}.select-field[disabled] .md-select-icon,.select-field[disabled] .md-select-value{color:rgba(0,0,0,.54)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/card/card.scss
// module id = 720
// module chunks = 0